import axiosInstance from '../../core/axiosConfig';
export class RestaurantItemService {
  async createItem(payload: any) {
    await axiosInstance.post('/menu-item/create', payload, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  async updateItem(payload: any) {
    await axiosInstance.patch('/menu-item/update', payload, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  async lockUnlockItem(menuItemId: Number) {
    await axiosInstance.patch(`/menu-item/item/lock-unlock?menuItemId=${menuItemId}`);
  }

  async getItems(id: number, language: string) {
    const response = await axiosInstance.get('/menu-item/get/admin', { params: { id, language } });
    return response.data;
  }

  async deleteItem(menuItemId: number) {
    await axiosInstance.delete('/menu-item/delete', { params: { menuItemId } });
  }

  async addSuggestedProduct(payload: any) {
    await axiosInstance.patch('/menu-item/suggested-product/update', payload);
  }
}
